import type { SortDirection } from '@tanstack/react-table';

import { SortLabelIcon } from './sort-label-icon';
import styles from './sort-label.module.css';

export interface SortLabelProps {
  /**
   * Sorting direction.
   * 'asc' - upwards(default)
   * 'desc' - downwards
   */
  direction?: SortDirection;
  /**
   * Is current column sort active
   */
  active?: boolean;
}

export const SortLabel = ({ active, direction = 'desc' }: SortLabelProps) => {
  return (
    <div className={styles.iconContainer}>
      <SortLabelIcon active={active} direction={direction} />
    </div>
  );
};
